module.exports = __webpack_public_path__ + "media/images/empty_image_large-70dc809fbbeeb435ee90fcc7bd8f9394.png";